import { forwardRef } from "react";
import { Link, type InertiaLinkProps } from "@inertiajs/react";
import { NEEDS_NETWORK, useOnline } from "@/hooks/useOnline";

/** A link to a screen only the server can render: inert offline, with a hint. */
const OnlineLink = forwardRef<HTMLAnchorElement, InertiaLinkProps>(function OnlineLink(props, ref) {
  const online = useOnline();
  if (online) return <Link ref={ref} {...props} />;

  const { className = "", children, "aria-label": ariaLabel, "aria-current": ariaCurrent } = props;
  return (
    <a
      ref={ref}
      role="link"
      aria-disabled="true"
      aria-label={ariaLabel}
      aria-current={ariaCurrent}
      title={NEEDS_NETWORK}
      className={`${className} cursor-not-allowed opacity-40`}
    >
      {children as React.ReactNode}
    </a>
  );
});

export default OnlineLink;
